// removed by extract-text-webpack-plugin
module.exports = {"footer":"_1ceHCMu9om14DBUbjo89zl","container":"sehj05HTttWxqPDcsQMPq","slink-group":"IYHB4zwP13BKMv8LHFega","links":"Ol_Q8PHlWFLWgg1dCEBVJ","social":"_3g6ukn58k0QaB8mT2-VaOL","logo-link":"cyIyyNvRCtvCZvNru3Fc1","followUsLabel":"_1XaLfJS91xcggLsYD7rQ6R","stock":"_2Gj0T4uTA1fbppeeXC0ASp","stock-value":"_24771MkMYOdKsz8UdTAnSC","stock-difference":"utvFcKnHe10pJvPioda9O","is-visible":"YGHGNDNGFZs_-1T8uF70T","stock-difference-positive":"_1jb73g7cMk9Muc2yYI8S3k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Footer.module.scss
// module id = 766
// module chunks = 0